import { dataforsyningenApiSlice } from "../apiSlice";

export const locationApiSlice = dataforsyningenApiSlice.injectEndpoints({
  tagTypes: ['Location'], // Tag type for invalidation
  endpoints: (builder) => ({
    // Fetch all energy groups
    getLocation: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['Location'],
    }),
  }),
});

export const {
    useLazyGetLocationQuery,
} = locationApiSlice;